/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';

import type { NewCoreIconProps } from '@atlaskit/icon';
import Tile, { type TileProps } from '@atlaskit/tile';
import { token } from '@atlaskit/tokens';

import { ICON_CYCLER_TEST_ID_SUFFIX } from './constants';
import IconCycler from './icon-cycler';
import type { IconComponent, SlideMorphProps } from './types';

const tileContainerPropsMap: Record<
	NonNullable<SlideMorphProps['appearance']>,
	Omit<TileProps, 'label'>
> = {
	default: {
		backgroundColor: 'color.background.neutral',
		hasBorder: false,
		size: 'xlarge',
	},
	subtle: {
		backgroundColor: 'white',
		hasBorder: true,
		size: 'xlarge',
	},
};

const iconPropsMap: Record<
	NonNullable<SlideMorphProps['appearance']>,
	Omit<NewCoreIconProps, 'label'>
> = {
	default: {
		color: token('color.icon.subtle'),
	},
	subtle: {
		color: token('color.icon.subtlest'),
	},
};

export default function SlideMorph({
	animationDisabled = false,
	icons,
	testId,
	appearance = 'default',
	cycleDirection = 'right',
}: SlideMorphProps) {
	const iconsWithProps = icons.map(
		(Icon) =>
			((props: NewCoreIconProps) => (
				<Icon {...iconPropsMap[appearance]} {...props} />
			)) as IconComponent,
	);

	return (
		<Tile label="" testId={testId} {...tileContainerPropsMap[appearance]}>
			<IconCycler
				animationDisabled={animationDisabled}
				icons={iconsWithProps}
				cycleDirection={cycleDirection}
				testId={testId ? `${testId}--${ICON_CYCLER_TEST_ID_SUFFIX}` : undefined}
			/>
		</Tile>
	);
}
